import * as React from 'react';
import { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { userpool, REQUIRED_GROUP } from '../src/api.js';

const defaultTheme = createTheme();

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);


  const handleLogin = (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    const authenticationData = {
      Username: username,
      Password: password
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);

    const userData = {
      Username: username,
      Pool: userpool
    };

    const cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        // Get the ID token payload to check group membership
        const idToken = result.getIdToken();
        const payload = idToken.decodePayload();
        const userGroups = payload['cognito:groups'] || [];
        
        // Validate that the user belongs to the required group
        if (!userGroups.includes(REQUIRED_GROUP)) {
          setLoading(false);
          setError('You do not have access to the Researcher Dashboard. Please sign up with a researcher registration code.');
          cognitoUser.signOut();
          return;
        }
        
        sessionStorage.setItem("access_token", idToken.getJwtToken());
        sessionStorage.setItem("refresh_token", result.getRefreshToken().getToken());
        sessionStorage.setItem("token_expiry", idToken.getExpiration());
        sessionStorage.setItem("logged_in_user", username);
        setLoading(false);
        // Redirect or perform any action upon successful login
        navigate('/Dashboard');
      },
      onFailure: (err) => {
        setLoading(false);
        console.error('Error authenticating user:', err);
        if (err.code === 'NotAuthorizedException') {
          setError('Incorrect username or password.');
        } else if (err.code === 'UserNotFoundException') {
          setError('No account found with this username.');
        } else {
          setError(err.message || 'Login failed. Please try again.');
        }
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        setLoading(false);
        // User needs to set a new password
        console.log('New password required:', userAttributes, requiredAttributes);
        setError('Password reset required. Please contact support.');
      }
    });
  };



  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: '#1F72E7' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Log in
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Researcher Dashboard
          </Typography>
          
          {error && (
            <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
              {error}
            </Alert>
          )}
          
          <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Email Address"
              name="username"
              autoComplete="email"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
                sx={{ mt: 3, mb: 2, backgroundColor: '#1F72E7', textTransform: 'none' }}

            >
              {loading ? 'Signing In...' : 'Log in'}
            </Button>
            <Grid container>
              <Grid item xs>

              </Grid>
              <Grid item>
                <Link href="/signup" variant="body2" sx={{ color: '#1F72E7' }}>
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>

      </Container>
    </ThemeProvider>
  );
}